import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { warehousesAPI } from '../../lib/api';

const Warehouses = () => {
  const [warehouses, setWarehouses] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchWarehouses = async () => {
    setLoading(true);
    try {
      const response = await warehousesAPI.getAll();
      setWarehouses(response.data);
    } catch (error) {
      console.error('Error fetching warehouses:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWarehouses();
  }, []);

  const columns = [
    { key: 'name', label: 'Warehouse Name' },
    { key: 'location', label: 'Location' },
    { key: 'capacity', label: 'Capacity' },
    { key: 'manager', label: 'Manager' },
    { key: 'status', label: 'Status', type: 'status' },
  ];

  const formFields = [
    { name: 'name', label: 'Warehouse Name', required: true, placeholder: 'Enter warehouse name' },
    { name: 'location', label: 'Location', placeholder: 'Address or location' },
    { name: 'capacity', label: 'Capacity', type: 'number', defaultValue: 0 },
    { name: 'manager', label: 'Manager', placeholder: 'Warehouse manager name' },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      defaultValue: 'active',
      options: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
      ],
    },
  ];

  const handleAdd = async (data) => {
    await warehousesAPI.create(data);
    fetchWarehouses();
  };

  const handleEdit = async (id, data) => {
    await warehousesAPI.update(id, data);
    fetchWarehouses();
  };

  const handleDelete = async (id) => {
    await warehousesAPI.delete(id);
    fetchWarehouses();
  };

  return (
    <DataTable
      title="Warehouses"
      description="Manage warehouse locations"
      data={warehouses}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
    />
  );
};

export default Warehouses;
